import * as fp from 'lodash/fp';
import { Observable, rx } from '@shared/rx';

/**
 * Gets the property value at path of object. If the resolved value is undefined the defaultValue is used
 * in its place.
 *
 * @param path         The path of the property to get.
 * @param defaultValue The value returned if the resolved value is undefined.
 */
export const pluckOr =
  <R>( // eslint-disable-line
    path: string | string[],
    defaultValue?: R,
  ) =>
  (o$: Observable<any>): Observable<R> =>
    o$.pipe(rx.map(fp.getOr(defaultValue, path)));
